// extracted by mini-css-extract-plugin
export default {"tabs":"navigation-manage-menu_tabs__7vtK6"};